import {Injectable} from '@angular/core';
import {TransmissionService} from "./transmission.service";
import {HttpClient} from "@angular/common/http";
import {HttpErrorHandlerService} from "../http-error-handler.service";
import {JWTService} from "../../authentication/jwt.service";
import {PasteboxService} from "../../services/pastebox.service";
import {ConstantService} from "../../services/constant.service";
import {FilterProductPreview} from "../../filter/interface/filter-product-preview";
import {FilterPayloadResponse} from "../interface/filter-payload-response";
import {ProductMetadataInfo} from "../../filter/interface/product-metadata-info";
import {RequestMapperService} from "../../request-mapper.service";
import {ColorListPayload} from "../interface/color-list-payload";
import {MaterialListPayload} from "../interface/material-list-payload";
import {PatternListPayload} from "../interface/pattern-list-payload";
import {FilterRelatedProducts} from "../../filter/interface/filter-related-products";
import {FilterSEO} from "../../filter/interface/filter-seo";
import {StoryProductFilter} from "../../stories/interface/story-product-filter";

@Injectable({
  providedIn: 'root'
})
export class FilterTransmissionService extends TransmissionService {

	constructor(
		_http: HttpClient,
		_httpErrorHandler: HttpErrorHandlerService,
		_jwt: JWTService,
		_pastebox: PasteboxService
	) {
		super(
			_http,
			_httpErrorHandler,
			_jwt,
			_pastebox
		);
	}

	public getStoryFilterResult(
		id:number,
		onPreExecute: () => void,
		onPostExecute: (response: StoryProductFilter) => void,
		onSuccess: (response: StoryProductFilter) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void{
		this.executeGetPayload<FilterPayloadResponse,StoryProductFilter>(
			RequestMapperService.GET_STORY_FILTER + id,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.STORY_PRODUCTS_ATTRIBUTE_KEY,
			false
		);
	}

	public getFilterResult(
		url:string,
		onPreExecute: () => void,
		onPostExecute: (response: FilterProductPreview[]) => void,
		onSuccess: (response: FilterProductPreview[]) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void{
		this.executeGetPayload<FilterPayloadResponse,FilterProductPreview[]>(
			url,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.PRODUCTS_ATTRIBUTE_KEY,
			false
		);
	}


	public getFabricRelatedResult(
		csv_product_id: string,
		onPreExecute: () => void,
		onPostExecute: (response: FilterRelatedProducts[]) => void,
		onSuccess: (response: FilterRelatedProducts[]) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void{
		this.executeGetPayload<FilterPayloadResponse,FilterRelatedProducts[]>(
			RequestMapperService.GET_FILTER_RELATED + csv_product_id,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.RELATED_PRODUCTS_ATTRIBUTE_KEY,
			false
		);
	}

	public resolveColorList(
		onPreExecute: () => void,
		onPostExecute: (response: ProductMetadataInfo[]) => void,
		onSuccess: (response: ProductMetadataInfo[]) => void,
		onFailure: (error: string) => void,
		onComplete: () => void
	): void {
		this.executeGetPayload<ColorListPayload, ProductMetadataInfo[]>(
			RequestMapperService.GET_COLOR_LIST,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.COLOR_LIST_ATTRIBUTE_KEY,
			false
		);

	};

	public resolveMaterialList(
		onPreExecute: () => void,
		onPostExecute: (response: ProductMetadataInfo[]) => void,
		onSuccess: (response: ProductMetadataInfo[]) => void,
		onFailure: (error: string) => void,
		onComplete: () => void
	): void {
		this.executeGetPayload<MaterialListPayload, ProductMetadataInfo[]>(
			RequestMapperService.GET_MATERIAL_LIST,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.MATERIAL_LIST_ATTRIBUTE_KEY,
			false
		);

	};

	public resolvePatternList(
		onPreExecute: () => void,
		onPostExecute: (response: ProductMetadataInfo[]) => void,
		onSuccess: (response: ProductMetadataInfo[]) => void,
		onFailure: (error: string) => void,
		onComplete: () => void
	): void {
		this.executeGetPayload<PatternListPayload, ProductMetadataInfo[]>(
			RequestMapperService.GET_PATTERN_LIST,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.PATTERN_LIST_ATTRIBUTE_KEY,
			false
		);

	};

	public resolveSEOData(
		code: 'SUB' | 'SEG' | 'CAT',
		name: string,
		onPreExecute: () => void,
		onPostExecute: (response: FilterSEO) => void,
		onSuccess: (response: FilterSEO) => void,
		onFailure: (error: string) => void,
		onComplete: () => void
	): void {
		this.executeGetPayload<PatternListPayload, FilterSEO>(
			RequestMapperService.GET_FILTER_SEO + code + '/' + name,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.FILTER_SEO_ATTRIBUTE_KEY,
			false
		);

	};

}
